import { GetAccountAppMetricsPerWorkspaceSummaryResponseDto } from '../../../../src/interface/dtos/top-apps/get-account-app-metrics-per-workspace-summary.response.dto';
import { LogManager } from '../../../common/port/log/log.manager.port';
import { GetAccountAppMetricsPerWorkspaceSummaryRequestDto } from '../../../../src/interface/dtos/top-apps/get-account-app-metrics-per-workspace-summary.request.dto';
import { GetAccountAppMetricsPerWorkspaceSummaryQuery } from '../../../../src/interface/queries/top-apps/get-account-app-metrics-per-workspace-summary.query';
import { AccountAppMetricsPerWorkspaceSummaryAggregateRootMapper } from '../../../../src/infrastructure/mappers/top-apps/account-app-metrics-per-workspace-summary.aggregate-root.mapper';

export class GetAccountAppMetricsPerWorkspaceSummaryController {
  constructor(
    protected readonly logManager: LogManager,
    protected readonly query: GetAccountAppMetricsPerWorkspaceSummaryQuery,
    protected readonly mapper: AccountAppMetricsPerWorkspaceSummaryAggregateRootMapper
  ) {}

  async get(
    props: GetAccountAppMetricsPerWorkspaceSummaryRequestDto
  ): Promise<GetAccountAppMetricsPerWorkspaceSummaryResponseDto> {
    try {
      const result = await this.query.execute(props);
      return this.mapper.toResponse(result);
    } catch (error) {
      throw new Error(
        `GetAccountAppMetricsPerWorkspaceSummaryController.get encountered an error ${error}`
      );
    }
  }
}
